import { render, staticRenderFns } from "./SkeletonUser.vue?vue&type=template&id=50ac1289&scoped=true"
var script = {}
import style0 from "./SkeletonUser.vue?vue&type=style&index=0&id=50ac1289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_etfl7lgzzfti5tuwpbu7orzhm4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac1289",
  null
  
)

export default component.exports